import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Button, Card, Alert } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';
import { FaGoogle } from 'react-icons/fa';
import './PhoneLogin.css';

const PhoneLogin = () => {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { googleSignIn } = useAuth();
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    try {
      setError('');
      setIsLoading(true);
      await googleSignIn();
      navigate('/');
      toast.success('Logged in successfully');
    } catch (err) {
      setError('Failed to sign in with Google');
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container 
      className="login-page-container"
    >
      <div className="login-card-wrapper">
        <Card className="login-card">
          <Card.Body className="login-card-body">
            <div className="login-header">
              <h2 className="login-title">Welcome to FarmX</h2>
              <p className="login-subtitle">Sign in to continue</p>
            </div>
            
            {error && (
              <Alert variant="danger" className="login-alert">
                {error}
              </Alert>
            )}
            
            <div className="google-login-section">
              <Button 
                variant="primary"
                onClick={handleGoogleSignIn}
                className="google-login-btn"
                disabled={isLoading}
                size="lg"
              >
                <FaGoogle className="google-icon" />
                <span className="google-btn-text">
                  {isLoading ? 'Signing in...' : 'Sign in with Google'}
                </span>
              </Button>
              
              <p className="login-help-text">
                Use your Google account to sign in to FarmX
              </p>
            </div>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default PhoneLogin; 